import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface CancelReturnInput {
    supplierOrderId: string;
    partIds: string[];
    reasonId: number;
    action: 'return' | 'cancellation';
    reOrder: boolean;
    comment?: string;
    /** Reason label from the cancel/return form, shown on the activity log. */
    reasonLabel?: string;
}

const cancelReturnParts = async (data: CancelReturnInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/order/parts/cancel-return`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useCancelReturnParts = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CancelReturnInput) => cancelReturnParts(data, sessionContext?.sessionId ?? null),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['/order/detail'] });
            queryClient.invalidateQueries({ queryKey: ['/order/activity-logs'] });
            queryClient.invalidateQueries({ queryKey: ['/order/drawer'] });
            queryClient.invalidateQueries({ queryKey: ['order-confirmation'] });
            queryClient.invalidateQueries({ queryKey: ['quoteData'] });
        },
        onError: (error) => {
            console.error('Failed to cancel/return parts:', error);
        }
    });
};

